import { render, staticRenderFns } from "./HomePostDefault.vue?vue&type=template&id=687ce2aa&scoped=true&"
import script from "./HomePostDefault.vue?vue&type=script&lang=js&"
export * from "./HomePostDefault.vue?vue&type=script&lang=js&"
import style0 from "./HomePostDefault.vue?vue&type=style&index=0&id=687ce2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687ce2aa",
  null
  
)

export default component.exports